// extracted by mini-css-extract-plugin
export default {"webhooks":"NotFound_webhooks__sRYpq"};